import { Component } from '@angular/core';

@Component({
  selector: 'app-special-workorder-panel',
  templateUrl: './special-workorder-panel.component.html',
  styleUrls: ['./special-workorder-panel.component.scss']
})
export class SpecialWorkorderPanelComponent {

}
